import { getDangerStyles } from './variantStyles/danger';
import { getDisabledStyles } from './variantStyles/disabled';
import { getDisabledNoFeedbackStyles } from './variantStyles/disabledNoFeedback';
import { getErrorStyles } from './variantStyles/error';
import { getInformativeStyles } from './variantStyles/informative';
import { getNeutralStyles } from './variantStyles/neutral';
import { getNewnessStyles } from './variantStyles/newness';
import { getOnSurfaceStyles } from './variantStyles/onSurface';
import { getPrimaryStyles } from './variantStyles/primary';
import { getSecondaryStyles } from './variantStyles/secondary';
import { getSucessStyles } from './variantStyles/success';
import { getWarningStyles } from './variantStyles/warning';
export const getTagStyles = (FOUNDATIONS, FONT) => {
    return {
        // NO FEEDBACK
        ...getPrimaryStyles(FOUNDATIONS, FONT),
        ...getSecondaryStyles(FOUNDATIONS, FONT),
        ...getDangerStyles(FOUNDATIONS, FONT),
        ...getOnSurfaceStyles(FOUNDATIONS, FONT),
        ...getNewnessStyles(FOUNDATIONS, FONT),
        ...getDisabledNoFeedbackStyles(FOUNDATIONS, FONT),
        // FEEDBACK
        ...getInformativeStyles(FOUNDATIONS, FONT),
        ...getSucessStyles(FOUNDATIONS, FONT),
        ...getWarningStyles(FOUNDATIONS, FONT),
        ...getErrorStyles(FOUNDATIONS, FONT),
        ...getNeutralStyles(FOUNDATIONS, FONT),
        ...getDisabledStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map